import EfSection from '@elem/ui/ef-section';
import EfSpec from '@elem/ui/ef-spec';
import EfImg from '@elem/ui/ef-img';
import { useEffect, useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import styles from './index.module.scss';
import { useLang } from '@/i18n';

export default function TheComp() {
    const { t } = useLang('theProduct.MoreSmart');
    const items = [
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1732342800958/MoreSmart-1.png',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1732342740396/MoreSmart-h5-1.png',
            title: t('card1_title'),
            desc: t('card1_desc'),
        },
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1732342740573/MoreSmart-2.png',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1732342813214/MoreSmart-h5-2.png',
            title: t('card2_title'),
            desc: t('card2_desc'),
        },
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1732342740222/MoreSmart-3.png',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1732342739858/MoreSmart-h5-3.png',
            title: t('card3_title'),
            desc: t('card3_desc'),
        },
    ];

    const [isPC, setIsPC] = useState(true);
    useEffect(() => {
        if (typeof window !== 'undefined') {
            const callback = () => {
                setIsPC(window?.innerWidth > 1024);
            };
            callback();
            window.addEventListener('resize', callback);
            return () => window.removeEventListener('resize', callback);
        }
    }, []);

    return (
        <div className={styles.TheComp}>
            <EfSection hasAnimation={false} label={t('label')} title={t('title')} />
            {isPC ? (
                <ul className="items">
                    {items?.map((item, k) => (
                        <li className={`item item-${k + 1}`} key={k}>
                            <div className="item-info">
                                <p className="item-title">{item.title}</p>
                                <p className="item-desc">{item.desc}</p>
                            </div>
                            <div className="item-img">
                                <EfImg pc={item.pc} h5={item.h5} />
                            </div>
                        </li>
                    ))}
                </ul>
            ) : (
                <Swiper className="items" slidesPerView={'auto'} spaceBetween={16} initialSlide={0}>
                    {items?.map((item, idx) => (
                        <SwiperSlide className="item" key={idx}>
                            <div className="item-info">
                                <p className="item-title">{item.title}</p>
                                <p className="item-desc">{item.desc}</p>
                            </div>
                            <div className="item-img">
                                <EfImg pc={item.pc} h5={item.h5} />
                            </div>
                        </SwiperSlide>
                    ))}
                </Swiper>
            )}
            <EfSpec className="spec-x" />
        </div>
    );
}
